<template>
  <div class="menucard">
    <Head title="Café Wintower" />
   
    <div class="col-two">
      <div class="col-two--left">

        <h1>Café Wintower</h1>

        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. Ein Blick in unser Menu:</p>

        <div class="two-col">
          <div class="left">
            <div class="topic-wrapper">
              <span class="topictitle"> Bekannte bayrische Vorspeisen</span>  
              <div class="menu-item">
                <div>
                  <h2>Titel</h2>
                  <div>Lorem ipsum dolor sit amet, cons etetur sadipscing iposium calndra elitr</div>
                </div>
                <div class="price">
                  18
                </div>
              </div>
              <div class="menu-item">
                <div>
                  <h2>Titel</h2>
                  <div>Lorem ipsum dolor sit amet, consip osium calndraetetur sadipscing iposium calndra elitr</div>
                </div>
                <div class="price">
                  18
                </div>
              </div>
            </div>
            <div class="topic-wrapper">
              <span class="topictitle"> Neo bayrische Vorspeisen</span>  
              <div class="menu-item">
                <div>
                  <h2>Titel</h2>
                  <div>Lorem ipsum dolor sit amet, cons etetur sadipscing iposium calndra elitr</div>
                </div>
                <div class="price">
                  18
                </div>
              </div>
              <div class="menu-item">
                <div>
                  <h2>Titel</h2>
                  <div>Lorem ipsum dolor sit amet, consip osium calndraetetur sadipscing iposium calndra elitr</div>
                </div>
                <div class="price">
                  18
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="topic-wrapper">
              <span class="topictitle"> Hauptgang</span>  
              <div class="menu-item">
                <div>
                  <h2>Titel</h2>
                  <div>Lorem ipsum dolor sit amet, consetetur sadipscing iposium calndra elitr</div>
                </div>
                <div class="price">
                  18
                </div>
              </div>
              <div class="menu-item">
                <div>
                  <h2>Titel</h2>
                  <div>Lorem ipsum dolor sit amet, consetetur sadipscing iposium calndra elitr</div>
                </div>
                <div class="price">
                  18
                </div>
              </div>
            </div>
            <div class="topic-wrapper">
              <span class="topictitle"> Beilagen</span>  
              <div class="menu-item">
                <div>
                  <h2>Titel</h2>
                  <div>Lorem ipsum dolor sit amet, consetetur sadipscing iposium calndra elitr</div>
                </div>
                <div class="price">
                  18
                </div>
              </div>
              <div class="menu-item">
                <div>
                  <h2>Titel</h2>
                  <div>Lorem ipsum dolor sit amet, consetetur sadipscing iposium calndra elitr</div>
                </div>
                <div class="price">
                  18
                </div>
              </div>
            </div>
          </div>
        
        </div>

       


        <div id="menucard" v-if="1==2">
          <draggable
                  class="list-group"
                  :list="menutopics"
                  group="people"
                  item-key="id"
                  @change="ordertopics"
                >
                  <template #item="{ element }">
                    <div class="topic-wrapper">
                      <div class="crudrow">
                        <div class="topictitle"> 
                          <span v-if="editmenutopic != element.id" class="menutitle"> {{ element.name }}  </span> 
                          <input v-else type="text" v-model="element.name" />
                        </div>
                        <div class="crudaction">
                            <button @click="updateMenutopic(element)" v-if="editmenutopic == element.id">Speichern</button>
                            <span v-if="!element.menus || element.menus.length == 0" @click="deleteMenutopic(element.id)">Löschen</span>
                            <span @click="editmenutopic=element.id">Editieren</span>
                        </div>
                      </div>
                      <div class="menus">
                        <draggable
                              class="list-group"
                              :list="element.menus"
                              group="menus"
                              item-key="id"
                              @change="ordertopics"
                            >
                              <template #item="{ element }">
                                <div class="crudrow">
                                  <div class="list-group-item">
                                    <div class="titlerow"> 
                                      <span v-if="editmenu != element.id" class="menutitle">{{ element.title }}</span> 
                                      <input v-else type="text" v-model="element.title" />
                                      <div>
                                        <span v-if="editmenu != element.id">{{ element.price_small}}  &nbsp;|&nbsp; </span>
                                        <input v-else type="text" style="width:70px" v-model="element.price_small" />
                                        <span v-if="editmenu != element.id">{{ element.price}}</span>
                                        <input v-else type="text" style="width:70px" v-model="element.price" />
                                      </div>
                                    </div>
                                    <div v-if="editmenu != element.id">{{ element.text }}  </div>
                                    <div v-else><textarea v-model="element.text"> </textarea> </div>
                                  </div>
                                  <div class="crudaction">
                                    <button @click="updateMenu(element)" v-if="editmenu == element.id">Speichern</button>
                                    <span v-if="editmenu != element.id" @click="deleteMenu(element.id)">Löschen</span>
                                    <span @click="editmenu=element.id">Editieren</span>
                                  </div>
                                  </div>
                              </template>
                          </draggable>

                          <button v-if="!editmenu" @click="addMenu(element)">Menü hinzufügen</button>

                      </div>
                    </div>

                  </template>
          </draggable>
       <button v-if="!editmenu" @click="addMenutopic">Katgorie hinzufügen</button> -->




    </div>
    
       

      </div>
      <div class="col-two--right">
          <div class="weather"> 
            <a class="weatherwidget-io" href="https://forecast7.com/de/47d508d72/winterthur/" data-label_1="WINTERTHUR" data-label_2="Wetter" data-font="Open Sans" data-days="3" data-theme="pure" >WINTERTHUR Wetter</a>
          </div>
          <div class="today"><span><label>{{ weekday }}</label><i>{{ date }}</i></span></div>
          <div class="calendar-teaser"> 
            <vue-cal 
              ref="vuecal"
              locale="de"
              hide-view-selector
              :disable-views="['years', 'year', 'year','week','day']"
              active-view="month"
              :time-from="7 * 60" :time-to="22 * 60"
              :events="events"
              :on-event-click="onEventClick">
            </vue-cal>
          </div>
      </div>
    </div>
        
    
   
  </div>
</template>



<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import draggable from 'vuedraggable'

import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/de.js'
import 'vue-cal/dist/vuecal.css'


import $ from "jquery";


!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src='https://weatherwidget.io/js/widget.min.js';fjs.parentNode.insertBefore(js,fjs);}}(document,'script','weatherwidget-io-js');


export default {
  components: {
    Head,
    draggable,
    VueCal,
    $
  },
  layout: Layout,
  data() {
    return {
      editmenu: null,
      editmenutopic: null,
      drag: false,
      date: null,
      weekday: null
    }
  },
  props: {
    menutopics: Object,
   auth: Object,
    events: Object,
    locations: Object,
  },
  mounted() {
    this.$parent.bgimage = "/img/tower3.jpg";

    let app = this;
    let weekdays = ["Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag","Sonntag"];
    const today = new Date();
    const day = today.getDay();
    app.date = today.getDate();
    app.weekday = weekdays[day];

  },
  methods: {
     log() {
       alert(45);
     },
    ordertopics() {
       let app = this;
        this.$inertia.visit('/cafe/order', {
          method: 'post',
          data: {menutopics: app.menutopics},
          preserveState: true,
          preserveScroll: true,
        })
    },
    deleteMenu(id) {
      if (confirm('Are you sure you want to delete this item?')) {
        this.$inertia.delete(`/cafe/menu/${id}`)
      }
    },
    deleteMenutopic(id) {
      if (confirm('Are you sure you want to delete this item?')) {
        this.$inertia.delete(`/cafe/menutopic/${id}`)
      }
    },
    addMenu(topic){
      let order = topic.menus[topic.menus.length-1] ? topic.menus[topic.menus.length-1].order + 1 : 0;
      let id = "new-" + Math.random(10000000);
      topic.menus[topic.menus.length] = {order: order,id: id, menutopic_id: topic.id};
      this.editmenu=id;
    },
    addMenutopic(){
      let order = this.menutopics.length + 1;
      let id = "new-" + Math.random(10000000);
      this.menutopics[this.menutopics.length] = {name: '',order: order,id: id,menus:[]};
      this.editmenutopic=id;
    },
    updateMenu(menu){
      let app = this;
      this.$inertia.visit('/cafe/menu', {
          method: 'post',
          data: menu,
          only: [],
          preserveState: true,
          preserveScroll: true,
          onSuccess: page => {
            app.editmenu = false
          },
         
          onError: errors => { app.editmenu = false},
          onFinish: visit => {},
        })
    },
    updateMenutopic(menutopic){
      let app = this;
      this.$inertia.visit('/cafe/menutopic', {
          method: 'post',
          data: menutopic,
          only: [],
          preserveState: true,
          preserveScroll: true,
          onSuccess: page => {
            app.editmenutopic = false
          },
         
          onError: errors => { app.editmenu = false},
          onFinish: visit => {},
        })
    }
  },

}
</script>
